import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class LowStock extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateLowStock);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateLowStock);
  }

  /**
   * Updates the low stock notice when the selected variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateLowStock = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newLowStock = event.detail.data.html.querySelector(`low-stock[data-block-id="${this.dataset.blockId}"]`);

    if (!newLowStock) return;

    morph(this, newLowStock, { childrenOnly: true });
  };
}

if (!customElements.get('low-stock')) {
  customElements.define('low-stock', LowStock);
}
